// Club code → name shown on the card. Opta's full names don't fit a 110px card.
const CLUB_NAMES: Record<string, string> = {
  AND: 'Anderlecht',
  ANT: 'Antwerp',
  CER: 'Cercle',
  CHA: 'Charleroi',
  CLU: 'Club Brugge',
  GNK: 'Genk',
  GNT: 'Gent',
  KVK: 'Kortrijk',
  KVM: 'Mechelen',
  LAL: 'La Louvière',
  LOM: 'Lommel',
  OHL: 'OH Leuven',
  SKB: 'Beveren',
  STA: 'Standard',
  STG: 'Union SG',
  STV: 'STVV',
  WES: 'Westerlo',
  ZWA: 'Zulte Waregem',
};

export const clubName = (code: string | null | undefined): string | undefined =>
  code ? (CLUB_NAMES[code.toUpperCase()] ?? code.toUpperCase()) : undefined;
